import { useContext } from 'react';

// Components
import { Context } from '@/components/Store';

const ProductDescription = () => {
	const [state] = useContext(Context);

	return (
		<p className="product-description">
			{state?.bundle?.description ? state.bundle.description : null}
		</p>
	);
};

export { ProductDescription };
